export const appTitle = (route: string, user?: string) => {
  if (user) {
    return `CSOS | ${route} > ${user}`;
  }
  return `CSOS | ${route}`;
};
